export enum ContentFileState {
	UPLOADING = 1,
	QUEUED_FOR_PROCESSING = 2,
	PROCESSING = 3,
	READY = 4,
	ERROR = 5,
	NEW_NEVER_RENDERED = 6,
	IN_REVISION = 7
}
